import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { PaymentType, PaymentTypeCreateInput } from "@/interfaces/payment-type.interface";
import t2payService from "@/services/t2pay.service";
import { RequestsProps } from "@/types/requests.types";

export type Props = { formData: PaymentTypeCreateInput } & RequestsProps;

export type Return = {
  create: (props: Props) => Promise<PaymentType>;
} & UseLoadingReturn;

const useCreatePaymentType = (): Return => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } =
    useCreate<PaymentTypeCreateInput>({
      operation: (formData) => t2payService.createPaymentType(formData),
    });

  return { isLoading, startLoading, endLoading, loadingIcon, create };
};

export default useCreatePaymentType;
